var ListDropdownAwareFoundation = /** @class */ (function () {
    function ListDropdownAwareFoundation() {
        this._popupClasses = [];
        this._syncPopupWidth = false;
        this._optionLimit = 0;
        this._observeScroll = false;
        this._observeScrollThreshold = 0;
        this._highlightFirst = true;
    }
    Object.defineProperty(ListDropdownAwareFoundation.prototype, "syncPopupWidth", {
        get: function () {
            return this._syncPopupWidth;
        },
        set: function (value) {
            this._syncPopupWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListDropdownAwareFoundation.prototype, "highlightFirst", {
        get: function () {
            return this._highlightFirst;
        },
        set: function (value) {
            this._highlightFirst = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListDropdownAwareFoundation.prototype, "popupClasses", {
        get: function () {
            return this._popupClasses;
        },
        set: function (value) {
            if (typeof value === 'string') {
                value = [value];
            }
            if (Array.isArray(value)) {
                this._popupClasses = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListDropdownAwareFoundation.prototype, "observeScroll", {
        get: function () {
            return this._observeScroll;
        },
        set: function (value) {
            this._observeScroll = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListDropdownAwareFoundation.prototype, "observeScrollThreshold", {
        get: function () {
            return this._observeScrollThreshold;
        },
        set: function (value) {
            this._observeScrollThreshold = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListDropdownAwareFoundation.prototype, "optionLimit", {
        get: function () {
            return this._optionLimit;
        },
        set: function (value) {
            this._optionLimit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListDropdownAwareFoundation.prototype, "popupHeaderBuilder", {
        set: function (value) {
            this._popupHeaderBuilder = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListDropdownAwareFoundation.prototype, "popupFooterBuilder", {
        set: function (value) {
            this._popupFooterBuilder = value;
        },
        enumerable: true,
        configurable: true
    });
    ListDropdownAwareFoundation.prototype.applySelection = function () { };
    return ListDropdownAwareFoundation;
}());
export { ListDropdownAwareFoundation };
